import {Component, Input} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Ownership } from "../../models/ownership";
import { OwnershipControllerService } from "../../services/ownership/ownership-controller.service";
import { OwnershipValueType } from "./ownership-value-type";
import {TranslatedBaseError} from "../pages/TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "ownership",
  templateUrl: "./ownership.component.html",
  providers: [OwnershipControllerService, ToastrService],
})
export class OwnershipComponent extends TranslatedBaseError {

  @Input() public listIcons: boolean = true;
  @Input() public title: string;
  @Input() public ownership: Ownership;

  public constructor(private ownershipService: OwnershipControllerService,
                     public toastr: ToastrService, public translateService: TranslateService) {
      super(toastr, translateService);
  }

  public saveVisibleTo(ownershipType: OwnershipValueType) {
    this.ownership.visibleTo = ownershipType;
    this.save();
  }

  public saveEditableFor(ownershipType: OwnershipValueType) {
    this.ownership.editableFor = ownershipType;
    this.save();
  }

  private save() {
    if (this.ownership.id) {
      this.ownershipService.saveOwnership(this.ownership).subscribe(
        () => {
          this.responseSuccessful("Data is saved!");
        },
        (error) => this.showErrorMessage(error),
      );
    } else {
      this.ownershipService.createOwnership(this.ownership).subscribe(
        (data) => {
          this.ownership = data;
          this.responseSuccessful("Data is saved!");
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

}
